import styled from "@emotion/styled";
import theme from "@theme/";

const TableContainer = styled.div`
  margin: 2rem auto;
  width: 100%;
  max-width: 1060px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 5px 4px 30px rgba(0, 0, 0, 0.1);

  /* Large Screen (Default) */
  @media (min-width: 1500px) {
    max-width: 1400px;
  }

  /* Laptop Screen */
  @media (max-width: 1200px) {
    max-width: 1200px;
    margin: 1rem auto;
  }

  /* Tablet Screen */
  @media (max-width: 768px) {
    max-width: 500px;
    margin: 0.5rem auto;
    padding: 0 1rem;
  }

  /* Mobile Screen */
  @media (max-width: 480px) {
    margin: 0.5rem auto;
    padding: 0 0.5rem;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border: 1px solid #a8a8a8;
  border-collapse: collapse;
`;

const TableHeader = styled.thead`
  position: sticky;
  top: 0;
  background-color: #f8fafc;
  z-index: 3;
`;

const HeaderCell = styled.th`
  text-align: ${(props) => props.align || "left"};
  padding: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid #a8a8a8;
  border-collapse: collapse;
  align-items: center;
  vertical-align: top;
  white-space: nowrap;
  width: auto;
  color: black;
  background: linear-gradient(145deg, #f0f0f0, #e0e0e0);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
    -2px -2px 5px rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  transition: transform 0.2s, box-shadow 0.2s;

  &:first-child {
    position: sticky;
    left: 0;
    z-index: 2;
  }
`;

const TableBody = styled.tbody`
  width: 100%;
  table-layout: auto;
`;

const TableCell = styled.td`
  padding: 4px;
  font-size: 0.875rem;
  color: #4b5563;
  border: 1px solid #a8a8a8;
  border-collapse: collapse;
  text-align: left;
  vertical-align: top;
  white-space: nowrap;
  width: auto;

  &:first-child {
    position: sticky;
    left: 0;
    z-index: 2;
    background-color: white;
    color: black;
    white-space: wrap;
  }
`;

const ScrollableContainer = styled.div`
  max-height: 900px;
  overflow-y: auto;

  /* Custom scrollbar styles */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #a8a8a8;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.themeColor};
    border-radius: 4px;
  }
`;

const Checkbox = styled.input`
  height: 1rem;
  width: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #d1d5db;
`;

const Labell = styled.span`
  margin-left: 0.5rem;
  font-size: 0.875rem;
  color: #4b5563;
`;

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.2;
  font-family: "Charlie Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
`;

const Astrik = styled.span`
  color: red;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 15px 8px 15px;
  margin: 0px 0px 10px 0px;
`;

const Children = styled.div`
  flex: 1.3;
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
`;
const SC = {
  TableContainer,
  TableWrapper,
  Table,
  TableHeader,
  HeaderCell,
  TableBody,
  TableCell,
  Checkbox,
  Label,
  Labell,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  ScrollableContainer,
};

export default SC;
